export interface HomeyInfo {
  id: string;
  licenses: string[];
  platform: string;
  platformVersion: number;
  apiVersion: number;
  softwareVersion: string;
  language: string | null;
  model: string | null;
  name: string | null;
  region: string | null;
}

export interface CloudApiHomey extends HomeyInfo {
  authenticate: (options?: { reconnect?: boolean }) => Promise<import('homey-api').HomeyAPI>;
}

export interface LocalApiHomey extends HomeyInfo {
  platform: 'local';
}

export type HomeyConnectionTarget = CloudApiHomey | LocalApiHomey;

export type HomeyReconnectSource = { kind: 'cloud'; homey: CloudApiHomey } | { kind: 'local' };

export type ConnectionStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'reconnecting'
  | 'recovered';

export type TransportType = 'direct' | 'local' | 'relayed' | null;

export type HomeyScopes = Record<string, boolean>;

export function isAuthCapableSelectedHomey(homey: HomeyConnectionTarget): homey is CloudApiHomey {
  return 'authenticate' in homey && typeof homey.authenticate === 'function';
}
